module.exports = __webpack_public_path__ + "img/b79928d7bf28702f0f4c3a5348208f00.0a73623f.jpeg";